import styled from "styled-components";
import { Link } from "react-router-dom";

export const SectionWithdrawInfo = styled("div")`
  background: white;
  box-shadow: var(--box-shadow2);
  border-radius: var(--border-radius-1);
  padding: 10px;
  color: var(--blue-color-dark);
  width: 70%;
  margin: 0 auto;
`;
export const PriceChoicesButton = styled("button")`
  color: var(--blue-color-dark);
  border: 1px solid
    ${(props) =>
      props.active ? "var(--primary-color)" : "var(--blue-color-light)"};
  background: ${(props) =>
    props.active ? "var(--blue-color-light)" : "var(--white-color)"};
  padding: 5px;
  border-radius: var(--border-radius-1);
  width: 27%;
  text-align: center;
`;
